import { Component, OnInit, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { AppService } from '@app/services';

@Component({
  selector: 'app-menu-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: false
})
export class MainComponent implements OnInit {
  constructor(
    public appService: AppService,
    private location: Location
  ) {}

  ngOnInit() {
    this.onResize();
  }

  @HostListener('window:resize') private onResize() {
    if (window.innerWidth > 991) {
      this.location.back();
    }
  }
}
